import { getCookie } from '../utils/cookie';

import request, { apiURL } from '../utils/api';
class PayLeaseService {
  sendResidentEmails(
    organizationId: string,
    propertyId: string,
    applicationId: string,
  ) {
    const options = {
      method: 'POST',
      headers: {
        Authorization: getCookie('session_id'),
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        propertyId,
        applicationId,
      }),
    };
    return request(`${apiURL}/${organizationId}/paylease/emails`, options);
  }

  sendIndividualResidentEmail(
    organizationId: string,
    propertyId: string,
    customerId: string,
  ) {
    const options = {
      method: 'POST',
      headers: {
        Authorization: getCookie('session_id'),
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        propertyId,
        customerId,
      }),
    };
    return request(
      `${apiURL}/${organizationId}/paylease/email-resident`,
      options,
    );
  }
}

export default PayLeaseService;
